import type { ComponentType, SVGProps } from 'react'

import styles from './AudioHeroMobileHeader.module.css'

type TAudioHeroMobileHeaderAction = {
    label: string
    Icon: ComponentType<SVGProps<SVGSVGElement>>
    onClick: () => void
    onIntent?: () => void
    testID?: string
}

type TAudioHeroMobileHeaderProps = {
    action?: TAudioHeroMobileHeaderAction
}

/**
 * Mobile/tablet-only top row of the hero. Desktop keeps the same actions in the hero bar, so this
 * row hides there (port of audio-web `AudioHeroHeaderMobile`). Trap: with no action the row still
 * renders — audio-web reserves its height for every visitor, and returning null moves the hero 40px.
 */
export const AudioHeroMobileHeader = ({ action }: TAudioHeroMobileHeaderProps) => {
    const Icon = action?.Icon

    return (
        <div className={styles.header}>
            {action && Icon ? (
                <button
                    type="button"
                    className={styles.iconButton}
                    aria-label={action.label}
                    onPointerEnter={action.onIntent}
                    onPointerDown={action.onIntent}
                    onFocus={action.onIntent}
                    onClick={action.onClick}
                    data-test={action.testID}
                >
                    <Icon className={styles.icon} />
                </button>
            ) : null}
        </div>
    )
}
